module.exports = __webpack_public_path__ + "img/6-6.2b0ea934.png";